"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const WcaOfficersAndBoardIcon = createIcon({
  displayName: "WcaOfficersAndBoardIcon",
  viewBox: "0 0 45 40",
  path: (
    <>
      <path
        d="M29.25,40v-6.67h-9V11.11h-4.5v6.67H0V0h15.75v6.67h13.5V0h15.75v17.78h-15.75v-6.67h-4.5v17.78h4.5v-6.67h15.75v17.78h-15.75ZM33.75,13.33h6.75V4.44h-6.75v8.89ZM33.75,35.56h6.75v-8.89h-6.75v8.89ZM4.5,13.33h6.75V4.44h-6.75v8.89Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default WcaOfficersAndBoardIcon;
